import { combineReducers } from '@reduxjs/toolkit'

import mx_assembly  from './slice'

const rootReducer = combineReducers({
  mx_assembly,
});

export default rootReducer
